<template>
  <emd-modal
    :open="show"
    has-header
    @close="() => $emit('onCancel')"
  >
    <template v-slot:header>
      <h3 class="emd-text _color_default _type_caption _size_section">
        {{ $t('title') }}
      </h3>
    </template>
    <template v-slot:content>
      <emd-text size="regular">
        {{ $t('content.phrase-1') }}
        <b class="_type_bold">
          {{ $t('content.phrase-2') }}
          {{ item.start }}
          {{ $t('content.phrase-3') }}
          {{ item.end }}.
        </b>
        {{ $t('content.phrase-4') }}
      </emd-text>
      <div class="eu-flex eu-justify_end">
        <emd-button
          class="eu-mr_2"
          color="primary"
          type="text"
          @click="$emit('onCancel')"
          >{{ $t('button-1') }}</emd-button
        >
        <emd-button
          color="primary"
          @click="$emit('onCopy', item)"
          >{{ $t('button-2') }}</emd-button
        >
      </div>
    </template>
  </emd-modal>
</template>
<script>
import { EmdModal, EmdText, EmdButton } from 'emerald-vue/src/components'
export default {
  name: 'CopyToAllConfirmationaModal',
  components: {
    EmdModal,
    EmdText,
    EmdButton
  },
  props: {
    show: Boolean,
    item: Object
  }
}
</script>
<i18n>
    {
        "pt-BR": {
            "title": "Replicar horário",
            "content.phrase-1": "Você selecionou o ",
            "content.phrase-2": "horário ",
            "content.phrase-3": "até ",
            "content.phrase-4": "Deseja replicá-lo para os dias restantes?",
            "button-1": "Cancelar",
            "button-2": "Replicar"
        },
        "en-US": {
            "title": "Replicate hours",
            "content.phrase-1": "You have selected the ",
            "content.phrase-2": "time of ",
            "content.phrase-3": "to ",
            "content.phrase-4": "Do you want to replicate it to the remaining days?",
            "button-1": "Cancel",
            "button-2": "Replicate"
        }
    }
</i18n>
